import { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import eventBus from '@/services/eventBus'
import recoilStateUpdaters from '@/recoil/recoil.stateUpdaters.ts'
import alarmSituationsAtom from '../alarmSituations.atom.ts'

const useAlarmSituationsEventsSubscriptions = () => {
  const setState = useSetRecoilState(alarmSituationsAtom)

  useEffect(() => {
    const createSub = eventBus.sub('alarmSituations.created', (item) => {
      recoilStateUpdaters.itemCreated(setState, item)
    })

    const updateSub = eventBus.sub('alarmSituations.updated', (item) => {
      recoilStateUpdaters.itemUpdated(setState, item)
    })

    const removeSub = eventBus.sub('alarmSituations.deleted', (id) => {
      recoilStateUpdaters.itemDeleted(setState, id)
    })

    return () => {
      createSub()
      updateSub()
      removeSub()
    }
  }, [])
}

export default useAlarmSituationsEventsSubscriptions
